
import { useResellerPlansState } from './resellerPlans/useResellerPlansState';
import { createPlanOperations } from './resellerPlans/planOperations';
import { defaultResellerPlan } from './resellerPlans/defaultPlans';
import type { ResellerPlanDetails } from './resellerPlans/types';

// Export types for convenience
export type { ResellerPlanDetails, PlanFeature } from './resellerPlans/types';

/**
 * Hook for managing reseller plans
 * @param readOnly If true, returns default data without loading from API/storage
 */
export const useResellerPlans = (readOnly: boolean = false) => {
  // Use read-only mode for components that just need the structure but not real data
  if (readOnly) {
    console.log("Using read-only reseller plans");
    return {
      resellerPlan: defaultResellerPlan,
      resellerPlans: [defaultResellerPlan],
      isLoadingPlans: false,
      isSavingPlans: false,
      saveResellerPlans: async () => true,
      updateResellerPlan: () => {},
      addResellerPlan: () => {},
      deleteResellerPlan: () => {}
    };
  }

  // Use state management for non-readonly mode
  const { resellerPlans, setResellerPlans, isLoading, isSaving, saveResellerPlans } = useResellerPlansState();
  
  // Get CRUD operations for plans
  const { updateResellerPlan, addResellerPlan, deleteResellerPlan } = createPlanOperations(
    resellerPlans, 
    setResellerPlans
  );

  return {
    // Current plan (first in the list or null if empty)
    resellerPlan: resellerPlans[0] || null,
    
    // All plans
    resellerPlans,
    
    // Loading states
    isLoadingPlans: isLoading,
    isSavingPlans: isSaving,
    
    // Save operation
    saveResellerPlans,
    
    // CRUD operations
    updateResellerPlan,
    addResellerPlan,
    deleteResellerPlan
  };
};
